import React, { useState } from 'react';
import FormBuilder from './FormBuilderTest'; // Import the FormBuilder component
import EditLabel from '../Components/EditLabel/EditLabel';
import { useForm } from 'react-hook-form';
import { Grid } from '@mui/material';

const ParentComponent: React.FC = () => {
  const [formSchema, setFormSchema] = useState<any>([]);
  const { control, setValue } = useForm()
  const handleSave = (schema: any) => {
    setFormSchema(schema); // Save the schema in the parent's state
    console.log('Received Schema in Parent:', schema);
  };

  return (
    <div>
      <h1>Parent Component</h1>
      <Grid item container spacing={2}>
        <Grid item sm={6}>
          <EditLabel label={'Name'} control={control} id='text' name='text' setValue={setValue} apiUrl='/test'  text='my data' editType='text' />
        </Grid>
        <Grid item sm={6}>
          <EditLabel label={'Phone'} control={control} id='phone' name='phone' setValue={setValue} apiUrl='/test'  text='123-123-1111' editType='phone' />
        </Grid>
        <Grid item sm={6}>
          <EditLabel label={'Dropdown'} control={control} id='drop' name='drop' setValue={setValue} apiUrl='/test' text='My Data' options={[{label:'Text',value:'1'},{label:'My Data',value:'2'}]} editType='dropdown' />
        </Grid>
        <Grid item sm={6}>
          <EditLabel label={'Amount'} control={control} id='amount' name='amount' setValue={setValue} apiUrl='/test' text='24' editType='amount' />
        </Grid>
      </Grid>

      {/* <FormBuilder onSave={handleSave} />
      <h2>Generated JSON:</h2>
      <pre>{JSON.stringify(formSchema, null, 2)}</pre> */}
    </div>
  );
};

export default ParentComponent;
